import request from '@/utils/request'

export function list() {
  return request({
    url: '/client/nav/top/link/list',
    method: 'get'
  })
}

/**
 * 更新点击量
 */
export function updateClickCount(id) {
  return request({
    url: `/client/nav/top/link/updateClickCount/${id}`,
    method: 'put'
  })
}
